import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

enum FancyKeys {
  Left = '←',
  Right = '→',
  Up = '↑',
  Down = '↓',
  Command = '⌘',
}

@Component({
  selector: 'app-view-shortcuts',
  templateUrl: './view-shortcuts.component.html',
  styleUrls: ['./view-shortcuts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewShortcutsComponent implements OnInit {
  // Keys require a pronunciation entry when the screen reader would treat the key
  // as punction. For example "ctrl + ." would just be read as "control" and therefore
  // needs a sentence to explicitly tell the screen reader what to say.
  readonly shortcutGroups = [
    {
      label: 'Navigation',
      shortcuts: [
        {
          keys: [
            {
              shortcut: ',',
              pronunciation: 'Comma.',
            },
            {
              shortcut: 'Pg-Up',
              pronunciation: 'page-up',
            },
          ],
          label: 'Previous chapter',
        },
        {
          keys: [
            { shortcut: '.', pronunciation: 'Period.' },
            { shortcut: 'Pg-Down', pronunciation: 'Page-down.' },
          ],
          label: 'Next chapter',
        },
        {
          keys: [{ shortcut: '/', pronunciation: 'Forward slash.' }],
          label: 'Open Search',
        },
        {
          keys: [{ shortcut: 'Ctrl + Enter' }],
          label: 'Enter Fullscreen',
        },
        {
          keys: [
            {
              shortcut: 'Ctrl/Cmd + ,',
              pronunciation: 'Control or command plus comma.',
            },
          ],
          label: 'Toggle Description',
        },
        {
          keys: [{ shortcut: 'Shift + /' }],
          label: 'Open Help',
        },
      ],
    },
    {
      label: 'Tools',
      shortcuts: [
        {
          keys: [{ shortcut: '1' }],
          label: 'Use "Select" tool',
        },
        {
          keys: [{ shortcut: '2' }],
          label: 'Use "Hide" tool',
        },
        {
          keys: [{ shortcut: '3' }],
          label: 'Use "Fade" tool',
        },
        {
          keys: [{ shortcut: 'del', pronunciation: 'Delete.' }, { shortcut: 'backspace' }],
          label: 'Hide selected structure',
        },
        {
          keys: [{ shortcut: 'Shift + R' }],
          label: 'Reset chapter',
        },
        {
          keys: [
            {
              shortcut: 'Ctrl/Cmd + Z',
            },
          ],
          label: 'Undo',
        },
        {
          keys: [
            {
              shortcut: 'Ctrl/Cmd + Shift + Z',
            },
            {
              shortcut: 'Ctrl/Cmd + Y',
            },
          ],
          label: 'Redo',
        },
      ],
    },

    {
      label: 'Pan',
      shortcuts: [
        {
          keys: [{ shortcut: 'W' }],
          label: 'Pan up',
        },
        {
          keys: [{ shortcut: 'S' }],
          label: 'Pan down',
        },
        {
          keys: [{ shortcut: 'A' }],
          label: 'Pan left',
        },
        {
          keys: [{ shortcut: 'D' }],
          label: 'Pan right',
        },
        {
          keys: [{ shortcut: 'Shift + W' }],
          label: 'Slow pan up',
        },
        {
          keys: [{ shortcut: 'Shift + S' }],
          label: 'Slow pan down',
        },
        {
          keys: [{ shortcut: 'Shift + A' }],
          label: 'Slow pan left',
        },
        {
          keys: [{ shortcut: 'Shift + D' }],
          label: 'Slow pan right',
        },
      ],
    },
    {
      label: 'Rotate',
      shortcuts: [
        {
          keys: [{ shortcut: FancyKeys.Up }],
          label: 'Rotate up',
        },
        {
          keys: [{ shortcut: FancyKeys.Down }],
          label: 'Rotate down',
        },
        {
          keys: [{ shortcut: FancyKeys.Left }],
          label: 'Rotate left',
        },
        {
          keys: [{ shortcut: FancyKeys.Right }],
          label: 'Rotate right',
        },
        {
          keys: [
            {
              shortcut: `Shift + ${FancyKeys.Up}`,
            },
          ],
          label: 'Slow rotate up',
        },
        {
          keys: [
            {
              shortcut: `Shift + ${FancyKeys.Down}`,
            },
          ],
          label: 'Slow rotate down',
        },
        {
          keys: [
            {
              shortcut: `Shift + ${FancyKeys.Left}`,
            },
          ],
          label: 'Slow rotate left',
        },
        {
          keys: [
            {
              shortcut: `Shift + ${FancyKeys.Right}`,
            },
          ],
          label: 'Slow rotate right',
        },
      ],
    },

    {
      label: 'Zoom',
      shortcuts: [
        {
          keys: [{ shortcut: 'E' }, { shortcut: '=' }],
          label: 'Zoom in',
        },
        {
          keys: [{ shortcut: 'C' }, { shortcut: '-' }],
          label: 'Zoom out',
        },
        {
          keys: [{ shortcut: 'Shift + E' }, { shortcut: 'Shift + =' }],
          label: 'Slow zoom in',
        },
        {
          keys: [
            { shortcut: 'Shift + C' },
            { shortcut: 'Shift + -', pronunciation: 'Shift plus hyphen.' },
          ],
          label: 'Slow zoom out',
        },
      ],
    },
  ];

  constructor() {}

  ngOnInit() {}
}
